import { Skeleton, Stack, SxProps, Theme } from '@mui/material';

interface GenericSkeletonProps {
    lines?: number;
    sx?: SxProps<Theme>;
    skeletonSx?: SxProps<Theme>;
}

export const GenericSkeleton = ({
    lines = 5,
    sx = {},
    skeletonSx = { height: '30px', width: '100%' },
}: GenericSkeletonProps) => {
    return (
        <Stack spacing={2} sx={sx}>
            {Array.from(Array(lines).keys()).map((key) => (
                <Skeleton key={key} variant="rounded" animation="wave" sx={skeletonSx} />
            ))}
        </Stack>
    );
};
